<template>
  <div style="background: #f4f4f4">
    <!-- 聊天内容 -->
    <div class="recordBox" @click.stop="blank()">
      <div v-for="(item, index) in recordList" :key="index" class="recordInfo">
        <div class="time">{{ item.time }}</div>
        <!-- 用户 -->
        <div class="content" v-if="item.fid != 'admin'">
          <div class="textContent bg-ash" v-html="item.content"></div>
          <div class="headImg">
            <img :src="userHead" alt="" />
          </div>
        </div>
        <!-- 客服 -->
        <div class="contentTwo" v-if="item.fid == 'admin'">
          <div class="headImg">
            <img :src="kefuHead" alt="" />
          </div>
          <div class="textContentTwo bg-ash" v-html="item.content"></div>
        </div>
      </div>
    </div>
    <!-- 底部 -->
    <div class="foot" :class="{ 'foot-activate': isExpression }">
      <div class="footOne">
        <textarea name="comment" placeholder="请输入评论" v-model="comment" rows="1" @focus="changeColor"></textarea>
        <div class="expression">
          <img src="../assets/image/expression.png" alt="" @click="expression" />
          <div class="send" @click="send()" v-throttle>发送</div>
        </div>
      </div>
      <!-- 表情 -->
      <div class="look">
        <ul>
          <li v-for="(item, index) in faceList" :key="index" @click="getBrow(index)">
            <img :src="item.icon" alt="" />
          </li>
        </ul>
      </div>
    </div>
    <div class="toast" v-show="toastShow"> {{ toastText }} </div>
  </div>
</template>
<script>
/**
 * Created by www.xingnuocn.com
 * @title：聊天
 *
 * @author: 刘嘉鑫
 * @version  V1.0
 * @datecreate: 2022-04-06 11:07
 */
const appData = require("../assets/common/emotions.json");
export default {
  data() {
    return {
      recordList: [], // 聊天列表
      page: 1, // 聊天记录分页
      comment: "", // 评论内容
      user_id: "", // 用户id
      style: "", // 聊天类型:1=技师,2=用户
      toid: "admin", ///admin  平台聊天是固定的admin
      isExpression: false, // 是否显示表情
      faceList: [], // 表情列表
      userHead: "", // 用户头像
      kefuHead: "", // 客服头像

      toastShow: false,
      toastText: "",
    };
  },
  mounted() {
    this.user_id = this.$route.query.user_id; //用户id
    this.style = this.$route.query.style; //聊天类型:1=技师,2=用户
    this.initWebSocket(); // websocket 初始化

    this.chatRecord();
    // this.scrollToBottom(); // 滚到最底部
    // this.getUserHead(); // 用户信息

    this.faceList = appData;

    // this.isRead();
    // let that = this;
    // setInterval(function () {
    //   that.isRead();
    // }, 5000);
  },
  methods: {
    /**
     * Created by www.xingnuocn.com
     * @title：初始化
     *
     * @author: 刘嘉鑫
     * @version  V1.0
     * @datecreate: 2022-04-06 11:07
     */
    initWebSocket() {
      //初始化websocket
      this.ws = new WebSocket("ws://ttsm.xingnuo.vip/ws");
      // this.ws = new WebSocket("ws://47.93.116.108:7275");
      this.ws.onmessage = this.websocketonmessage;
      this.ws.onopen = this.websocketonopen;
      this.ws.onerror = this.websocketonerror;
      this.ws.onclose = this.websocketclose;
    },

    // 连接
    websocketonopen() {
      console.log("连接 websocket 成功");
    },

    // 连接失败时重新连接
    websocketonerror() {
      this.initWebSocket();
    },
    // 断开链接后报错
    websocketclose(e) {
      console.log("断开连接", e);
      //this.initWebSocket() //断开后重新连接
    },

    /**
     * Created by www.xingnuocn.com
     * @title：接收消息
     *
     * @author: 刘嘉鑫
     * @version  V1.0
     * @datecreate: 2022-04-06 11:07
     */
    websocketonmessage(e) {
      console.log("收到服务端的消息：" + e.data);
      var data = JSON.parse(e.data);
      switch (data["type"]) {
        case "login":
          var bild = `{"type":"bild","room_id":"${this.user_id}","client_id":"${data.client_id}"}`;
          console.log(bild);
          this.bindingRelation(bild); // 绑定uid
          this.ws.send(bild);
          break;
        case "bild":
          var id = data.room_id;
          if (!id) {
            alert("房间出错！");
          }
          break;
        case "save":
          this.save_message(data);
          let dataTwo = data;
          // 解析表情包
          let newContentTwo = dataTwo["content"].split("]");
          let imgTwo = "";
          for (let j in this.faceList) {
            for (let i in newContentTwo) {
              if (newContentTwo[i] != "") {
                let newTwo = `${newContentTwo[i]}]`;
                if (newTwo == this.faceList[j].value) {
                  imgTwo += ` <img src="${this.faceList[j].icon}" alt="" style="margin-right:4px;margin-bottom:4px;width:48px;height:48px;display:inline-block;" />`;
                }
              }
            }
          }
          dataTwo["content"] = imgTwo != "" ? imgTwo : dataTwo["content"];
          this.recordList = this.recordList.concat(dataTwo);
          this.comment = "";
          return;
        case "service":
          console.log("收到消息", data);
          // data["head_img"] = this.$root.baseUrl + data["head_img"]; // 拼接客服头像
          // 解析表情包
          let newContent = data["content"].split("]");
          let img = "";
          for (let j in this.faceList) {
            for (let i in newContent) {
              if (newContent[i] != "") {
                let newTwo = `${newContent[i]}]`;
                if (newTwo == this.faceList[j].value) {
                  img += ` <img src="${this.faceList[j].icon}" alt="" style="margin-right:4px;margin-bottom:4px;width:48px;height:48px;display:inline-block;" />`;
                }
              }
            }
          }
          data["content"] = img != "" ? img : data["content"];
          let fid = { fid: "admin" };
          let newData = Object.assign({}, data, fid);
          this.recordList = this.recordList.concat(newData);
          return;
      }
    },

    /**
     * Created by www.xingnuocn.com
     * @title：绑定关系
     *
     * @author: 刘嘉鑫
     * @version  V1.0
     * @datecreate: 2022-04-07 16:24
     */
    bindingRelation(bild) {
      this.$axios({
        method: "post",
        headers: {
          "Content-Type": "application/json",
          // "Content-Type": "application/x-www-form-urlencoded",
        }, // 请求头
        url: `${this.$root.baseUrl}/Userchat/chatbind`,
        data: {
          client_id: JSON.parse(bild).client_id,
          room_id: JSON.parse(bild).room_id,
          style: this.style,
        },
      }).then((result) => {
        console.log(result.data);
        this.userHead = result.data.data.avatar; // 用户头像
        this.kefuHead = result.data.data.kefu; // 客服头像
        window.Android.sendClientId(JSON.parse(bild).client_id); // 传参给安卓
      });
    },

    /**
     * Created by www.xingnuocn.com
     * @title：发送消息
     *
     * @author: 刘嘉鑫
     * @version  V1.0
     * @datecreate: 2022-04-06 11:08
     */
    send() {
      if (this.comment != "") {
        // var message = `{"type":"say","id":"2","name":"admin","content":"${this.comment}","room_id":"${this.user_id}","style":"${this.style}" }`;
        var message = {
          type: "say",
          id: "2",
          name: "admin",
          content: this.comment,
          room_id: this.user_id,
          style: this.style,
        };
        this.$axios({
          method: "post",
          headers: {
            "Content-Type": "application/json",
            // "Content-Type": "application/x-www-form-urlencoded",
          }, // 请求头
          url: `${this.$root.baseUrl}/Userchat/chatSend`,
          data: message,
        }).then((result) => {
          console.log(result);
          if (result.data.code == 1) {
            this.comment = "";
            this.ws.send(message);
            this.isExpression = false;

            let newContent = message["content"].split("]");
            let img = "";
            for (let j in this.faceList) {
              for (let i in newContent) {
                if (newContent[i] != "") {
                  let newTwo = `${newContent[i]}]`;
                  if (newTwo == this.faceList[j].value) {
                    img += ` <img src="${this.faceList[j].icon}" alt="" style="margin-right:4px;margin-bottom:4px;width:48px;height:48px;display:inline-block;" />`;
                  }
                }
              }
            }
            message["content"] = img != "" ? img : message["content"];
            let newData = Object.assign({}, message);
            this.recordList = this.recordList.concat(newData);

            this.keywordReturn(message)
          } else {
            this.toast(result.data.msg);
          }
        });
      }
    },

    /**
     * Created by www.xingnuocn.com
     * @title：后台返回数据
     *
     * @author: 刘嘉鑫
     * @version  V1.0
     * @datecreate: 2022-04-06 11:08
     */
    keywordReturn(data) {
      console.log(data)
      this.$axios({
        method: "post",
        headers: {
          "Content-Type": "application/json"
          // "Content-Type": "application/x-www-form-urlencoded",
        }, // 请求头
        url: `${this.$root.baseUrl}/Userchat/sendMessageReply`,
        data: data,
      }).then((result) => {
        console.log("根据关键字返回", result);
      });
    },

    /**
     * Created by www.xingnuocn.com
     * @title：聊天记录
     *
     * @author: 刘嘉鑫
     * @version  V1.0
     * @datecreate: 2022-04-06 11:08
     */
    chatRecord() {
      this.$axios({
        method: "post",
        headers: {
          "Content-Type": "application/json",
          // "Content-Type": "application/x-www-form-urlencoded",
        }, // 请求头
        url: `${this.$root.baseUrl}/Userchat/chatRecord`,
        data: {
          room_id: this.user_id,
          style: this.style,
          toid: 2,
          page: this.page,
        },
      }).then((result) => {
        console.log("聊天记录", result);
        let data = result.data.data;
        this.userHead = data[0].f_avatar;
        for (let k in data) {
          let newContent = data[k].content.split("]");
          let img = "";
          for (let j in this.faceList) {
            for (let i in newContent) {
              if (newContent[i] != "") {
                let newTwo = `${newContent[i]}]`;
                if (newTwo == this.faceList[j].value) {
                  img += `<img src="${this.faceList[j].icon}" alt="" style="margin-right:4px;margin-bottom:4px;width:48px;height:48px;display:inline-block;" />`;
                }
              }
            }
          }
          data[k].content = img != "" ? img : data[k].content;
        }
        this.recordList = data;
      });
    },

    /**
     * Created by www.xingnuocn.com
     * @title：获取用户信息
     *
     * @author: 刘嘉鑫
     * @version  V1.0
     * @datecreate: 2022-04-06 11:08
     */
    getUserHead() {
      this.$axios({
        method: "post",
        headers: {
          //   "Content-Type": "application/json"
          "Content-Type": "application/x-www-form-urlencoded",
        }, // 请求头
        url: `${this.$root.baseUrl}/userapi/Kefuchat/getUserHeadImg`,
        data: {
          user_id: this.user_id,
        },
      }).then((result) => {
        console.log("用户信息", result);
        this.userHead = result.data.user_head_img;
      });
    },

    /**
     * Created by www.xingnuocn.com
     * @title：表情
     *
     * @author: 刘嘉鑫
     * @version  V1.0
     * @datecreate: 2022-04-06 11:08
     */
    expression() {
      this.isExpression = !this.isExpression;
      if (this.isExpression == true) {
        this.faceList = appData;
      } else {
        this.faceList = [];
      }
    },
    // 获取用户点击之后的标签 ，存放到输入框内
    getBrow(index) {
      console.log(index);
      for (let i in this.faceList) {
        if (index == i) {
          this.getBrowString = this.faceList[index].value;
          this.comment += this.getBrowString;
        }
      }
    },

    // 点击聊天。表情框隐藏
    blank() {
      if (this.isExpression == true) {
        this.isExpression = false;
      }
    },

    // textarea  获取焦点  隐藏表情框
    changeColor() {
      if (this.isExpression == true) {
        this.isExpression = false;
      }
    },

    /**
     * Created by www.xingnuocn.com
     * @title：消息已读
     *
     * @author: 刘嘉鑫
     * @version  V1.0
     * @datecreate: 2022-04-06 11:08
     */
    isRead() {
      this.$axios({
        method: "post",
        headers: {
          //   "Content-Type": "application/json"
          "Content-Type": "application/x-www-form-urlencoded",
        }, // 请求头
        url: `${this.$root.baseUrl}/userapi/Kefuchat/read`,
        data: {
          user_id: this.user_id,
        },
      }).then((result) => {
        console.log("消息已读", result);
      });
    },

    // toast
    toast(str) {
      let v = this;
      v.toastText = str;
      v.toastShow = true;
      setTimeout(function () {
        v.toastShow = false;
      }, 1500);
    },
  },

  /**
   * Created by www.xingnuocn.com
   * @title：滚动条在底部
   *
   * @author: 刘嘉鑫
   * @version  V1.0
   * @datecreate: 2022-04-06 11:08
   */
  scrollToBottom() {
    this.$nextTick(() => {
      setTimeout(() => {
        var container = this.$el.querySelector(".recordBox");
        // console.log(container.scrollHeight);
        document.body.scrollTop = container.scrollHeight;
        // console.log(document.body.scrollTop);
      }, 10);
    });
  },

  //每次页面渲染完之后滚动条在最底部
  updated: function () {
    // this.scrollToBottom();
    this.$nextTick(() => {
      var container = this.$el.querySelector(".recordBox");
      // console.log(container.scrollHeight);
      document.documentElement.scrollTop = container.scrollHeight;
      // console.log(document.body.scrollTop);
    });
  },

  beforeRouteEnter(to, from, next) {
    // 添加背景色
    document
      .querySelector("body")
      .setAttribute("style", "background-color:rgb(244, 244, 244)");
    next();
  },
};
</script>
<style lang='scss' scoped>
.chatBox {
  background: #f4f4f4;
  width: 100%;
  height: 100vh;
}

.recordBox {
  margin-bottom: 120px;
  padding: 60px 40px;
}

.recordInfo {
  margin-bottom: 60px;
}

.recordInfo:last-child {
  margin-bottom: 0 !important;
}

.expression {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 35%;
}

.expression img {
  width: 54px;
  height: 54px;
  margin-right: 30px;
}

.send {
  background: #00c3a1;
  border-radius: 34px;
  padding: 21px 25px;
  font-size: 26px;
  font-weight: bold;
  color: #ffffff;
}

.time {
  font-size: 28px;
  font-weight: 400;
  color: #999999;
  margin-bottom: 30px;
  text-align: center;
}

.content {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.content img {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  margin-left: 28px;
  object-fit: cover;
}

.textContent {
  padding: 20px;
  border-radius: 14px;
  display: -webkit-inline-box;
  display: -webkit-inline-flex;
  display: inline-flex;
  flex-wrap: wrap;
  max-width: 75%;
  -webkit-box-align: center;
  -webkit-align-items: center;
  align-items: center;
  font-size: 32px;
  position: relative;
  text-align: left;
  word-break: break-all;
}

.textContent::after {
  content: "";
  -webkit-transform: rotate(45deg);
  transform: rotate(45deg);
  position: absolute;
  display: inline-block;
  overflow: hidden;
  width: 20px;
  height: 20px;
  left: auto;
  right: -8px;
  background-color: inherit;
  border-radius: 2px;
  overflow-x: hidden;
  overflow-y: hidden;
  border-top-left-radius: 1px;
  border-top-right-radius: 1px;
  border-bottom-right-radius: 1px;
  border-bottom-left-radius: 1px;
}

.headImg {
  width: 20%;
}

.contentTwo {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.contentTwo img {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  margin-right: 2.8px;
  object-fit: cover;
}

.bg-ash {
  background-color: #e8e8e8;
  color: #222222;
}

.textContentTwo {
  padding: 20px;
  border-radius: 14px;
  display: -webkit-inline-box;
  display: -webkit-inline-flex;
  display: inline-flex;
  flex-wrap: wrap;
  max-width: 75%;
  -webkit-box-align: center;
  -webkit-align-items: center;
  align-items: center;
  font-size: 32px;
  position: relative;
  text-align: left;
  word-break: break-all;
}

.textContentTwo::after {
  content: "";
  -webkit-transform: rotate(45deg);
  transform: rotate(45deg);
  position: absolute;
  display: inline-block;
  overflow: hidden;
  width: 20px;
  height: 20px;
  left: -8px;
  right: auto;
  background-color: inherit;
  border-radius: 2px;
  overflow-x: hidden;
  overflow-y: hidden;
  border-top-left-radius: 1px;
  border-top-right-radius: 1px;
  border-bottom-right-radius: 1px;
  border-bottom-left-radius: 1px;
}

.foot {
  background-color: #ffffff;
  position: fixed;
  bottom: 0;
  padding: 22px 0 0;
  width: 100%;
  transition: 0.4s all;
  transform: translateY(79%);
}

// 渐出动画
.foot-activate {
  transition: 0.4s all;
  transform: translateY(0%);
  opacity: 1;
  visibility: visible;
}

.footOne {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 32px;
}

.footOne textarea {
  font-size: 28px;
  font-weight: 400;
  color: #222222;
  background: #f2f2f2;
  border-radius: 76px;
  width: 60%;
  padding: 24px 34px;
  border: none;
  resize: none;
  outline: none;
}

.footOne textarea::placeholder {
  font-weight: 400;
  color: #aaaaaa;
}

.look {
  background: #f4f4f4;
  margin: 20px 0 0;
  width: 100%;
  height: 460px;
  overflow: scroll;

  ul {
    display: flex;
    flex-wrap: wrap;
    padding: 16px 10px 10px;
    margin-top: 0 !important;

    li {
      width: 14%;
      list-style: none;
      text-align: center;
      margin-bottom: 8px;

      img {
        width: 60%;
      }
    }
  }
}

.toast {
  position: fixed;
  z-index: 2000;
  left: 50%;
  top: 45%;
  transition: all 0.5s;
  -webkit-transform: translateX(-50%) translateY(-50%);
  -moz-transform: translateX(-50%) translateY(-50%);
  -ms-transform: translateX(-50%) translateY(-50%);
  -o-transform: translateX(-50%) translateY(-50%);
  transform: translateX(-50%) translateY(-50%);
  text-align: center;
  border-radius: 5px;
  color: #fff;
  background: rgba(17, 17, 17, 0.7);
  height: 45px;
  line-height: 45px;
  padding: 0 16px;
  font-size: 26px;
}
</style>